




import { Vue, Component, Prop, Watch } from "vue-property-decorator";
declare let AMap: any;
import _ from "lodash";
import trafficPolicyService from "@/service/trafficPolicyService";

@Component({
  name: "drivingMap",
  components: {},
})
export default class drivingMap extends Vue {
  map: any = "";
  mounted() {
    this.map = new AMap.Map("container", {
      resizeEnable: true,
      zoom: 15.2,
      zoomToAccuracy: true,
      showIndoorMap: false,
      center: "",
      mapStyle: "amap://styles/5b5d2e8e958a60b0e2085a7748ad5c4e",
    });
  }

  currentAddress: any = "";
  geolocation: any = "";
  location() {
    AMap.plugin("AMap.Geolocation", () => {
      this.geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        buttonOffset: new AMap.Pixel(10, 20),
        zoomToAccuracy: true,
        panToLocation: true,
        showButton: false,
        showMarker: false,
        showCircle: false,
        useNative: true,
      });
      this.map.addControl(this.geolocation);
      this.geolocation.getCurrentPosition((status: any, result: any) => {
        if (status == "complete") {
          this.currentAddress = [result.position.lng, result.position.lat];
          this.$emit("location", this.currentAddress);
        }
      });
    });
  }
  passPolyline: any = [];
  planPolyline: any = [];
  // 路线规划获得轨迹点位
  driving: any = "";
  planning(departAddress: number[], arriveAddress: number[]) {
    trafficPolicyService.routePlan(departAddress.join(","), arriveAddress.join(",")).then((response: any) => {
      if (response.status != "1" || !response.route || !response.route.paths) return;
      let route = response.route.paths[0];
      route.steps.forEach((s: any) => (s.path = s.polyline.split(";").map((o: string) => o.split(","))));
      let paths = this.parseRouteToPath(route);
      this.$emit("planning", paths);
      this.drawPath(route, this.map);
    });
    // let __self = this;
    // AMap.plugin("AMap.Driving", () => {
    //   // 判断规划是否存在,存在的话清掉
    //   if (__self.driving) {
    //     __self.driving.clear();
    //   }
    //   __self.driving = new AMap.Driving({ policy: AMap.DrivingPolicy.LEAST_TIME });
    //   __self.driving.search(departAddress, arriveAddress, (status: any, result: any) => {
    //     if (result.info == "OK") {
    //       __self.planPolyline = _.map(result.routes[0].steps, item => [item.start_location.lng, item.start_location.lat]);
    //       __self.$emit("planning", result.routes[0]);
    //       __self.trackPlayback();
    //     }
    //   });
    // });
  }

  int2hex(num: number) {
    var hex = "0123456789abcdef";
    var s = "";
    while (num) {
      s = hex.charAt(num % 16) + s;
      num = Math.floor(num / 16);
    }
    return s;
  }

  drawPath(route: any, map: any) {
    var track = [];
    let steps = route.steps; //.slice(0, 2);
    let line = [];
    for (var i = 0, l = steps.length; i < l; i++) {
      var step = steps[i];
      let color = this.int2hex((i * 10) % 255);
      let speed = step.distance / step.time;
      if (speed < 1) {
        line.push({ path: step.path, borderWeight: 0, outlineColor: `#ff0000`, strokeColor: `#ff0000` });
      } else if (speed < 3) {
        line.push({ path: step.path, borderWeight: 0, outlineColor: `#fda52b`, strokeColor: `#fda52b` });
      }

      for (var j = 0, n = step.path.length; j < n; j++) {
        track.push(step.path[j]);
      }
    }
    // line.splice(0, 0, { path: track, borderWeight: 2, outlineColor: `#ffeeee`, strokeColor: `#0091ff` });
    line.splice(0, 0, { path: track, borderWeight: 2, outlineColor: `#ffeeee`, strokeColor: `#28f` });

    line.forEach(l => this.createPolyline(l.path, 5, l.strokeColor, l.borderWeight, l.outlineColor));
    map.setFitView();
  }

  // 解析DrivingRoute对象，构造成AMap.Polyline的path参数需要的格式
  // DrivingResult对象结构参考文档 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DriveRoute
  parseRouteToPath(route: any) {
    var path = [];

    for (var i = 0, l = route.steps.length; i < l; i++) {
      var step = route.steps[i];

      for (var j = 0, n = step.path.length; j < n; j++) {
        path.push(step.path[j]);
      }
    }
    return path;
  }

  // polyline: any = "";
  // carMarker: any = "";
  // 轨迹运动
  // trackPlayback() {
  //   if (this.carMarker) {
  //     this.map.remove(this.carMarker);
  //   }
  //   var icon = new AMap.Icon({
  //     size: new AMap.Size(40, 50), // 图标尺寸
  //     image: "https://webapi.amap.com/images/car.png", // Icon的图像
  //     imageSize: new AMap.Size(30, 20), // 根据所设置的大小拉伸或压缩图片
  //   });
  //   this.carMarker = new AMap.Marker({
  //     map: this.map,
  //     position: this.planPolyline[0],
  //     icon: icon,
  //     offset: new AMap.Pixel(-26, -13),
  //     autoRotation: true,
  //     angle: -90,
  //   });
  //   var strIcon = new AMap.Icon({
  //     // size: new AMap.Size(25,25), // 图标尺寸
  //     image: "https://a.amap.com/jsapi_demos/static/resource/img/user.png", // Icon的图像
  //     imageSize: new AMap.Size(25, 25), // 根据所设置的大小拉伸或压缩图片
  //   });
  //   var strMarker = new AMap.Marker({ position: this.planPolyline[this.planPolyline.length - 1], icon: strIcon, offset: new AMap.Pixel(-13, -23) });
  //   this.map.add(strMarker);

  //   // 绘制轨迹
  //   if (this.polyline) {
  //     this.map.remove(this.polyline);
  //   }
  //   this.polyline = new AMap.Polyline({
  //     map: this.map,
  //     path: this.planPolyline,
  //     showDir: true,
  //     strokeColor: "#28F", //线颜色
  //     strokeWeight: 8, //线宽
  //     lineJoin: "round", // 折线拐点连接处样式
  //     zIndex: 50,
  //   });

  //   var passedPolyline = new AMap.Polyline({
  //     map: this.map,
  //     path: this.passPolyline,
  //     showDir: true,
  //     strokeColor: "#dfdfdf", //线颜色
  //     strokeWeight: 8, //线宽
  //     zIndex: 49,
  //   });

  //   this.map.setFitView();

  //   this.carMarker.moveAlong(this.planPolyline, 500);
  // }

  clearMap() {
    this.map.clearMap();
  }
  fitView() {
    this.map.setFitView();
  }
  createOverMarker(options: any, image: any, offset: any) {
    let iconOptions: any = {
      image: image.path,
      imageSize: new AMap.Size(image.width || 20, image.height || 30),
    };
    let iconSize = undefined;
    if (image.size) {
      iconOptions.size = new AMap.Size(image.size.width, image.size.height);
    }
    options.icon = new AMap.Icon(iconOptions);
    offset = offset || { x: -10, y: -23 };
    options.offset = new AMap.Pixel(offset.x, offset.y);

    var marker = new AMap.Marker(options);
    this.map.add(marker);
    return marker;
  }

  createOverText(text: string, location: any) {
    new AMap.Text({ map: this.map, text: `<div class="getCarInfo">${text}</div>`, anchor: "center", cursor: "pointer", offset: new AMap.Pixel(0, -35), position: location });
  }

  createPolyline(path: number[], strokeWeight: number = 5, strokeColor: string = "`#28f", borderWeight: number = 0, outlineColor: string = "#ffeeee") {
    return new AMap.Polyline({
      map: this.map,
      path: path,
      isOutline: true,
      outlineColor: outlineColor,
      borderWeight: borderWeight,
      strokeWeight: strokeWeight,
      strokeColor: strokeColor,
      lineJoin: "round",
    });
  }

  beforeDestroy() {
    let __self = this;
    __self.map.destroy();
    console.log("map destroy");
  }
}
